// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SeparatorView__Separator___KHDGF{border-left:1px solid #cacaca;height:24px;opacity:1}.SeparatorView__Separator___KHDGF,.SeparatorView__SeparatorModernViewer___1JRh0{margin-right:8px}", ""]);
// Exports
exports.locals = {
	"Separator": "SeparatorView__Separator___KHDGF",
	"SeparatorModernViewer": "SeparatorView__SeparatorModernViewer___1JRh0"
};
module.exports = exports;
